import { getRecommendations, includesDynamicSelectorObserver } from '~/actions/feed';
import RS from '~/api';
import { START_PREVIEW_FEED_STRING_NAME_PROCESS } from '~/utils/PreviewFeed/constants';
import { parseUrlHash } from '~/utils/parseUrlHash';

/**
 * Проверяет хэш, и возвращает feedId ленты
 * @returns feedId - иденификатор ленты
 */
const checkHash = (): string => {
  let feedId: string = '';
  const hash = parseUrlHash();
  if (
    hash?.type &&
    hash?.type === START_PREVIEW_FEED_STRING_NAME_PROCESS &&
    hash?.feedId
  ) {
    feedId = hash.feedId;
  }

  return feedId;
};

const start = (feedId: string): void => {
  window.clickstreamAnalyticUtilitiesDemo = {
    isDemo: true,
    hash: `#type=${START_PREVIEW_FEED_STRING_NAME_PROCESS}&feedId=${feedId}`,
  };
  RS.feedList.get('PREVIEW').then((result: IFeedList) => {
    if (result.payload.length > 0) {
      includesDynamicSelectorObserver(result.payload);
      result.payload.forEach((feed) => {
        getRecommendations(feed);
      });
    }
  });
};

/**
 * Инициализирует предварительный показ ленты рекомендаций
 */
export const initPreviewFeed = () => {
  const feedId = checkHash();
  if (feedId) start(feedId);
};
